<div class="relative">
  <label class="block text-sm font-medium text-ink" [for]="inputId()">{{ label() }}</label>
  <input
    [id]="inputId()"
    type="text"
    inputmode="text"
    autocomplete="off"
    [value]="query()"
    [placeholder]="placeholder()"
    (input)="onInput($any($event.target).value)"
    (focus)="onFocus()"
    (blur)="onBlur()"
    class="mt-1.5 w-full rounded-lg border border-line px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-forest/30"
  />

  @if (open() && suggestions().length) {
    <ul
      class="absolute z-10 mt-1 max-h-64 w-full overflow-auto rounded-lg border border-line bg-white py-1 shadow-lg"
    >
      @for (s of suggestions(); track s.postcode + s.locality + s.state) {
        <li>
          <button
            type="button"
            (mousedown)="select(s)"
            class="flex w-full items-center justify-between gap-2 px-3 py-2 text-left text-sm text-ink transition hover:bg-creamdark/50"
          >
            <span>{{ s.locality }}, {{ s.state }}</span>
            <span class="text-ink/50">{{ s.postcode }}</span>
          </button>
        </li>
      }
    </ul>
  }
</div>
